/* eslint-disable @typescript-eslint/naming-convention */
export enum POLLQUESTIONTYPE {
  '1-10_SCALE' = '1-10_SCALE',
  'BOOLEAN' = 'BOOLEAN',
  '1-5_SCALE' = '1-5_SCALE',
  'FREE_TEXT' = 'FREE_TEXT'
}
